var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gbwaps-app",attrs:{"id":"app"}},[_c('SiteHeader'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('StickyDownload'),_vm._v(" "),_c('SiteFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }